export const sagaActions = {
  API_CALL_START: "API_CALL_START",
  API_CALL_END: "API_CALL_END",
  API_FAILED: "API_FAILED",

  SPICES_LOAD: "SPICES_LOAD",
  SPICES_LOAD_REQUEST: "SPICES_LOAD_REQUEST",

  INCENSES_LOAD_REQUEST: "INCENSES_LOAD_REQUEST",
  INCENSES_LOAD: "INCENSES_LOAD",

  HOME_LOOKUPS_LOAD_REQUEST: "HOME_LOOKUPS_LOAD_REQUEST",
  HOME_LOOKUPS_LOAD: "HOME_LOOKUPS_LOAD",

  CONTACTS_LOAD_REQUEST: "CONTACTS_LOAD_REQUEST",
  CONTACTS_LOAD: "CONTACTS_LOAD",

  USER_LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  USER_LOGIN: "USER_LOGIN",
  USER_LOGIN_FAILED: "USER_LOGIN_FAILED",
  USER_LOGOUT_REQUEST: "USER_LOGOUT_REQUEST",
  USER_LOGOUT: "USER_LOGOUT",
  USER_LOGOUT_FAILED: "USER_LOGOUT_FAILED",

  ORDERS_LOAD_REQUEST: "ORDERS_LOAD_REQUEST",
  ORDERS_LOAD: "ORDERS_LOAD",

  ORDERS_STATE_CHANGE_REQUEST: "ORDERS_STATE_CHANGE_REQUEST",
};
